import type { Capability } from '@bifeai/shared';
import { Card, CardBody, EmptyState } from '@bifeai/ui';
import { Lock } from 'lucide-react';
import type { ReactNode } from 'react';
import { useSession } from '../lib/session';

/** Muestra la pantalla solo si el usuario tiene alguno de los permisos. La API lo vuelve a controlar. */
export function Gate({ any, children }: { any: Capability[]; children: ReactNode }) {
  const { can } = useSession();
  if (any.some((c) => can(c))) return <>{children}</>;
  return (
    <Card>
      <CardBody>
        <EmptyState
          icon={<Lock />}
          title="No tenés acceso a esta sección"
          text="Si la necesitás, pedile al dueño que te habilite el permiso desde Usuarios."
        />
      </CardBody>
    </Card>
  );
}
